/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Extension_Popup_Recentdeliveries_Noneyet2Inputs */

const he_extension_popup_recentdeliveries_noneyet2 = /** @type {(inputs: Extension_Popup_Recentdeliveries_Noneyet2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`אין עדיין`)
};

const en_extension_popup_recentdeliveries_noneyet2 = /** @type {(inputs: Extension_Popup_Recentdeliveries_Noneyet2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`None yet`)
};

/**
* | output |
* | --- |
* | "None yet" |
*
* @param {Extension_Popup_Recentdeliveries_Noneyet2Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const extension_popup_recentdeliveries_noneyet2 = /** @type {((inputs?: Extension_Popup_Recentdeliveries_Noneyet2Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Extension_Popup_Recentdeliveries_Noneyet2Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_extension_popup_recentdeliveries_noneyet2(inputs)
	return en_extension_popup_recentdeliveries_noneyet2(inputs)
});
export { extension_popup_recentdeliveries_noneyet2 as "extension_popup_recentDeliveries_noneYet" }